"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCompress(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M8.936 14.298h.03a.77.77 0 01.045.003l-.075-.003a.77.77 0 01.667.389.73.73 0 01.092.273l.004.03a.77.77 0 01.003.043v6.158a.766.766 0 01-1.525.104l-.007-.104v-4.279l-6.862 6.864a.766.766 0 01-1.158-.998l.074-.086 6.863-6.863H2.809a.766.766 0 01-.76-.661l-.006-.104c0-.388.288-.708.662-.76l.104-.006h6.127zM23.776.224a.766.766 0 01.074.998l-.074.086-6.864 6.862h4.28c.387 0 .708.288.758.662l.007.104a.766.766 0 01-.662.76l-.104.006h-6.157a.77.77 0 01-.045-.003l.075.003a.77.77 0 01-.667-.389.73.73 0 01-.092-.273l-.004-.03a.77.77 0 01-.003-.043V2.809a.766.766 0 011.525-.104l.007.104-.001 4.278L22.692.224c.3-.299.785-.299 1.084 0z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCompress;
exports.default = _default;